import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isLinkPreviewInSelection = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === Node_Type.LINK_PREVIEW;
    });
    return !!node;
  }
  return false;
});
export {
  isLinkPreviewInSelection
};
//# sourceMappingURL=is-link-preview-in-selection.js.map
